import { z } from "zod";
export var DeviceCategoryEnum;
(function (DeviceCategoryEnum) {
    DeviceCategoryEnum["SUPPLY_AIR_DEVICE"] = "SUPPLY_AIR_DEVICE";
    DeviceCategoryEnum["CHILLER"] = "CHILLER_DEVICE";
    DeviceCategoryEnum["RETURN_AIR_DEVICE"] = "RETURN_AIR_DEVICE";
    DeviceCategoryEnum["LIGHT_DEVICE"] = "LIGHT_DEVICE";
    DeviceCategoryEnum["LIGHT_DEVICE_CIRCULAR"] = "LIGHT_DEVICE_CIRCULAR";
    DeviceCategoryEnum["DOWN_LIGHT"] = "DOWN_LIGHT_DEVICE";
    DeviceCategoryEnum["DEFAULT_DEVICE"] = "DEFAULT_DEVICE";
    DeviceCategoryEnum["FIRE_SUPPRESSION_DEVICE"] = "FIRE_SUPPRESSION_DEVICE";
    DeviceCategoryEnum["DOOR"] = "DOOR";
    DeviceCategoryEnum["WINDOW"] = "WINDOW";
    DeviceCategoryEnum["FURNITURE"] = "FURNITURE";
    DeviceCategoryEnum["SENSOR_DEVICE"] = "SENSOR_DEVICE";
})(DeviceCategoryEnum || (DeviceCategoryEnum = {}));
export var IfcClassesEnum;
(function (IfcClassesEnum) {
    IfcClassesEnum["IFCFURNITURE"] = "IfcFurniture";
    IfcClassesEnum["IFCCOLUMN"] = "IfcColumn";
    IfcClassesEnum["IFCDOOR"] = "IfcDoor";
    IfcClassesEnum["IFCWINDOW"] = "IfcWindow";
    IfcClassesEnum["IFCWALL"] = "IfcWall";
    IfcClassesEnum["IFCWALLSTANDARDCASE"] = "IfcWallStandardCase";
    IfcClassesEnum["IFCSENSOR"] = "IfcSensor";
    IfcClassesEnum["IFCAIRTERMINAL"] = "IfcAirTerminal";
    IfcClassesEnum["IFCLIGHTFIXTURE"] = "IfcLightFixture";
    IfcClassesEnum["IFCFIRESUPRESSIONTERMINAL"] = "IfcFireSuppressionTerminal";
    IfcClassesEnum["IFCCHILLER"] = "IfcChiller";
})(IfcClassesEnum || (IfcClassesEnum = {}));
export const ZDeviceTypesIfcInstanceClassesEnum = z.enum([
    "IfcAirTerminal",
    "IfcLightFixture",
    "IfcFireSuppressionTerminal",
    "IfcSensor",
    "IfcChiller",
]);
export const IFC_CLASSES_CEILING_DEVICES = Object.freeze([
    IfcClassesEnum.IFCSENSOR,
    IfcClassesEnum.IFCAIRTERMINAL,
    IfcClassesEnum.IFCLIGHTFIXTURE,
    IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL,
    IfcClassesEnum.IFCCHILLER,
]);
export const LENGTH_COMP_CLASSES = [
    "IfcFlowFitting",
    "IfcFlowSegment",
    "IfcCableCarrier",
    "IfcCableCarrierFitting",
    "IfcPipeSegment",
    "IfcDuctSegment",
    "IfcPipeFitting",
    "IfcCableFitting",
    "IfcCableCarrierSegment",
    "IfcDuctFitting",
];
export const ATTACHED_TO_LENGTH_COMP_CLASSES = [
    "IfcDamper",
    "IfcDuctSilencer",
    "IfcValve",
    "IfcFlowMeter",
    "IfcFlowInstrument",
    "IfcFilter",
    "IfcCoil",
];
export var DisciplineEnum;
(function (DisciplineEnum) {
    DisciplineEnum["VENTILATION"] = "VENTILATION";
    DisciplineEnum["ELECTRICAL"] = "ELECTRICAL";
    DisciplineEnum["SPRINKLER"] = "SPRINKLER";
    DisciplineEnum["ARCHITECTURE"] = "ARCHITECTURE";
    DisciplineEnum["UNKNOWN"] = "UNKNOWN";
})(DisciplineEnum || (DisciplineEnum = {}));
export const DEVICE_DISCIPLINE_MAPPING = {
    [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: DisciplineEnum.VENTILATION,
    [DeviceCategoryEnum.RETURN_AIR_DEVICE]: DisciplineEnum.VENTILATION,
    [DeviceCategoryEnum.LIGHT_DEVICE]: DisciplineEnum.ELECTRICAL,
    [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: DisciplineEnum.ELECTRICAL,
    [DeviceCategoryEnum.DOWN_LIGHT]: DisciplineEnum.ELECTRICAL,
    [DeviceCategoryEnum.SENSOR_DEVICE]: DisciplineEnum.ELECTRICAL,
    [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: DisciplineEnum.SPRINKLER,
    [DeviceCategoryEnum.DEFAULT_DEVICE]: DisciplineEnum.ARCHITECTURE,
    [DeviceCategoryEnum.DOOR]: DisciplineEnum.ARCHITECTURE,
    [DeviceCategoryEnum.WINDOW]: DisciplineEnum.ARCHITECTURE,
    [DeviceCategoryEnum.FURNITURE]: DisciplineEnum.ARCHITECTURE,
    [DeviceCategoryEnum.CHILLER]: DisciplineEnum.VENTILATION,
};
export const DEVICE_CATEGORY_IFC_INSTANCE_MAPPING = {
    [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: IfcClassesEnum.IFCAIRTERMINAL,
    [DeviceCategoryEnum.RETURN_AIR_DEVICE]: IfcClassesEnum.IFCAIRTERMINAL,
    [DeviceCategoryEnum.LIGHT_DEVICE]: IfcClassesEnum.IFCLIGHTFIXTURE,
    [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: IfcClassesEnum.IFCLIGHTFIXTURE,
    [DeviceCategoryEnum.DOWN_LIGHT]: IfcClassesEnum.IFCLIGHTFIXTURE,
    [DeviceCategoryEnum.SENSOR_DEVICE]: IfcClassesEnum.IFCSENSOR,
    [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: IfcClassesEnum.IFCFIRESUPRESSIONTERMINAL,
    [DeviceCategoryEnum.DEFAULT_DEVICE]: IfcClassesEnum.IFCFURNITURE,
    [DeviceCategoryEnum.DOOR]: IfcClassesEnum.IFCDOOR,
    [DeviceCategoryEnum.WINDOW]: IfcClassesEnum.IFCDOOR,
    [DeviceCategoryEnum.FURNITURE]: IfcClassesEnum.IFCFURNITURE,
    [DeviceCategoryEnum.CHILLER]: IfcClassesEnum.IFCCHILLER,
};
export const DEVICES_TYPES_SETTINGS = {
    [DeviceCategoryEnum.SUPPLY_AIR_DEVICE]: {
        color: "#0080c0",
        showDirectionInViewer: true,
        label: "Tilluft",
        description: "Luftdon klassifisert som tilluft.",
    },
    [DeviceCategoryEnum.RETURN_AIR_DEVICE]: {
        color: "#ffff00",
        showDirectionInViewer: false,
        label: "Avtrekk",
        description: "Luftdon klassifisert som avtrekk eller retur.",
    },
    [DeviceCategoryEnum.LIGHT_DEVICE]: {
        // Kvadratisk
        color: "#FFA500",
        showDirectionInViewer: false,
        label: "Belysning",
    },
    [DeviceCategoryEnum.LIGHT_DEVICE_CIRCULAR]: {
        color: "#a36e0c",
        showDirectionInViewer: false,
        label: "Belysning – rund",
    },
    [DeviceCategoryEnum.DOWN_LIGHT]: {
        color: "#becf83",
        showDirectionInViewer: false,
        label: "Downlight",
    },
    [DeviceCategoryEnum.DEFAULT_DEVICE]: {
        color: "#808080",
        showDirectionInViewer: false,
        label: "Øvrige komponenter",
    },
    [DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE]: {
        color: "#FF0000",
        showDirectionInViewer: false,
        label: "Sprinkler",
    },
    [DeviceCategoryEnum.DOOR]: {
        color: "#9e9e9e",
        showDirectionInViewer: false,
        label: "Dører",
    },
    [DeviceCategoryEnum.WINDOW]: {
        color: "#10d5d5",
        showDirectionInViewer: false,
        label: "Vinduer",
    },
    [DeviceCategoryEnum.FURNITURE]: {
        color: "#e4dfcd",
        showDirectionInViewer: false,
        label: "Møbler",
    },
    [DeviceCategoryEnum.SENSOR_DEVICE]: {
        color: "#bf00ff",
        showDirectionInViewer: false,
        label: "Sensorer",
    },
    [DeviceCategoryEnum.CHILLER]: {
        color: "#00f1dd",
        showDirectionInViewer: true,
        label: "Baffel",
    },
};
export var RIGHT_CLICK_DEVICE_MENU_ENUM;
(function (RIGHT_CLICK_DEVICE_MENU_ENUM) {
    RIGHT_CLICK_DEVICE_MENU_ENUM["DELETE"] = "Slett (backspace)";
    RIGHT_CLICK_DEVICE_MENU_ENUM["COPY"] = "Kopier (ctrl+c)";
    RIGHT_CLICK_DEVICE_MENU_ENUM["ROTATE"] = "Roter (ctrl+r)";
})(RIGHT_CLICK_DEVICE_MENU_ENUM || (RIGHT_CLICK_DEVICE_MENU_ENUM = {}));
